import { TokenUid } from "@silo/types";
import { Data, HashMap, HashSet, pipe } from "effect";

export class TokenMap<T> {
  private hashMap: HashMap.HashMap<TokenUid, T>;

  constructor() {
    this.hashMap = HashMap.empty();
  }

  public get(key: TokenUid) {
    const { chainKey, tokenAddress } = key;

    return HashMap.get(Data.struct({ chainKey, tokenAddress }))(this.hashMap);
  }

  public set(key: TokenUid, value: T) {
    const { chainKey, tokenAddress } = key;

    const newHashMap = HashMap.set(
      Data.struct({ chainKey, tokenAddress }),
      value
    )(this.hashMap);

    this.hashMap = newHashMap;
  }

  public size() {
    return HashMap.size(this.hashMap);
  }

  public entries() {
    return HashMap.entries(this.hashMap);
  }
}

export class TokenSet {
  private hashSet: HashSet.HashSet<TokenUid>;

  constructor() {
    this.hashSet = HashSet.empty();
  }

  public add(key: TokenUid) {
    const { chainKey, tokenAddress } = key;

    const newHashSet = pipe(
      this.hashSet,
      HashSet.add(Data.struct({ chainKey, tokenAddress }))
    );

    this.hashSet = newHashSet;
  }

  public values() {
    return pipe(this.hashSet, HashSet.values);
  }
}
